interface AvatarProps {
  src?: string;
  name: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function Avatar({ src, name, size = 'md', className = '' }: AvatarProps) {
  const sizeStyles = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-base',
  };

  const initials = name
    .split(' ')
    .map((word) => word[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

  if (src) {
    // referrerPolicy: an avatar URL (Clerk's profile images today, any remote
    // source tomorrow) must not carry our page URL — with the default policy
    // the full path, including the trip route, leaks to the image host on
    // every render (JAR-1164).
    return <img src={src} alt={name} referrerPolicy="no-referrer" className={`rounded-full object-cover ${sizeStyles[size]} ${className}`} />;
  }

  return (
    <div className={`rounded-full bg-brand text-brand-fg font-semibold flex items-center justify-center ${sizeStyles[size]} ${className}`}>
      {initials}
    </div>
  );
}
